import { z } from 'zod';

export const decisionSchema = z.object({
  id: z.string(),
  date: z.string(),
  title: z.string(),
  description: z.string(),
});
export type Decision = z.infer<typeof decisionSchema>;

export const lessonSchema = z.object({
  id: z.string(),
  section: z.string().nullable(),
  date: z.string().nullable(),
  title: z.string(),
  description: z.string(),
});
export type Lesson = z.infer<typeof lessonSchema>;

export const lessonsResponseSchema = z.object({
  content: z.string().default(''),
});

export type HistoryItem =
  | ({ kind: 'decision' } & Decision)
  | ({ kind: 'lesson' } & Lesson);
